<div class="box">
  <div class="year-month prizm-font-input-text-14px">
    <div class="month-box">
      <button
        class="pagination-btn"
        [attr.testId]="'prizm-primitive-year-month-pagination__year-button'"
        [class.active]="monthActive"
        [prizmFocusable]="true"
        [disabled]="oneMonth"
        (click)="onMonthClick($event)"
        type="button"
      >
        {{ value?.month | prizmMonth | async }}

        <prizm-icons-full *ngIf="!oneMonth" name="triangle-down"></prizm-icons-full>
      </button>
    </div>

    <div class="year-box">
      <button
        class="pagination-btn"
        [attr.data-testid]="'prizm-primitive-year-month-pagination__year-button'"
        [prizmFocusable]="true"
        [class.active]="yearActive"
        [disabled]="oneYear"
        (click)="onYearClick($event)"
        type="button"
      >
        {{ value.formattedYear }}
        <prizm-icons-full *ngIf="!oneYear" name="triangle-down"></prizm-icons-full>
      </button>
    </div>
  </div>
  <div>
    <prizm-primitive-spin-button
      [class.hidden]="hideButtons"
      [focusable]="false"
      [leftDisabled]="prevMonthDisabled"
      [rightDisabled]="nextMonthDisabled"
      (leftClick)="onPrevMonthClick()"
      (rightClick)="onNextMonthClick()"
    >
    </prizm-primitive-spin-button>
  </div>
</div>
